import { default as Column } from './Column';

export default Column;
